import { render, staticRenderFns } from "./RoleSyncSettings.vue?vue&type=template&id=fe55ad0a"
import script from "./RoleSyncSettings.vue?vue&type=script&lang=js"
export * from "./RoleSyncSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports